import React, { useState } from 'react';
import { caseStudiesData } from '../data/caseStudies';
import { CaseStudyCard } from './CaseStudyCard';
import { CaseStudyDetail } from './CaseStudyDetail';
import { CaseStudy } from '../types';
export function CaseStudies() {
  const [selectedStudy, setSelectedStudy] = useState<CaseStudy | null>(null);
  return <section id="work" className="py-24 md:py-32 border-t border-border" data-id="element-33">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-34">
        <div className="mb-16" data-id="element-35">
          <h2 className="text-2xl md:text-3xl font-semibold text-primary tracking-tight" data-id="element-36">
            Selected Work
          </h2>
        </div>

        <div className="flex flex-col gap-8" data-id="element-37">
          {caseStudiesData.map((study, index) => <CaseStudyCard key={study.id} study={study} index={index} onSelect={setSelectedStudy} data-id="element-38" />)}
        </div>
      </div>

      <CaseStudyDetail study={selectedStudy} isOpen={!!selectedStudy} onClose={() => setSelectedStudy(null)} data-id="element-39" />
    </section>;
}